import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AcreDappProvider } from "./providers/AcreDappProvider/AcreDappProvider";
import { Web3OnboardProvider, init } from "@web3-onboard/react";
import injectedModule from "@web3-onboard/injected-wallets";
import { MoralisProvider } from "react-moralis";

import Homepage from "./pages/Homepage";
import CreateListingLander from "./pages/CreateListingLander";
import CreateListingPage from "./pages/CreateListingPage";
import CreateCollectionListingPage from "./pages/CreateCollectionListingPage";
import ExplorePage from "./pages/ExplorePage";
import PropertyDetailPage from "./pages/PropertyDetailPage";
import AccountPageLayout from "./pages/account/AccountPageLayout";
import MyPropertiesPage from "./pages/account/MyPropertiesPage";
import MyBidsPage from "./pages/account/MyBidsPage";
import NotificationsPage from "./pages/account/NotificationsPage";
import ErrorPage from "./pages/ErrorPage";
import AccountHelpPage from "./pages/account/AccountHelpPage";
import AccountBlankPage from "./pages/account/AccountBlankPage";

function App() {

  return (
          <BrowserRouter>
            <Routes>
              <Route index element={<Homepage />} />
              <Route
                path="property/list/landing"
              element={<CreateListingLander />}
              />
              <Route path="property/list/new/single" element={<CreateListingPage />} />
              <Route path="property/list/new/collection" element={<CreateCollectionListingPage />} />
              <Route path="explore" element={<ExplorePage />} />
              <Route
                path="property/:listingId/:privateListing"
                element={<PropertyDetailPage />}
              />
              <Route path="account" element={<AccountPageLayout />}>
                <Route path="properties" element={<MyPropertiesPage />} />
                <Route path="bids" element={<MyBidsPage />} />
                <Route path="notifications" element={<NotificationsPage />} />
                <Route path="help" element={<AccountHelpPage />} />
                <Route path="*" element={<AccountBlankPage />} />
              </Route>
              <Route path="*" element={<ErrorPage status="404." />} />
            </Routes>
          </BrowserRouter>
  );
}

export default App;
